module.exports={
  "downloadData": "Download data",
  "latestUpdate": "Latest update",
  "visibility": "Visibility",
  "userLayers": "User Layers",
  "moreInformation": "More Information",
  "removeFromLegend": "Remove from Legend"
}
